<template>
  <div class="commonForm-container">
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      :inline="inline"
      :label-width="labelWidth"
    >
      <template v-for="item in formItemList">
        <!-- 输入框类型 -->
        <template v-if="item.type === 'input'">
          <el-form-item
            :label="item.label"
            :prop="item.model"
            :key="item.model"
          >
            <el-input
              v-model.trim="form[item.model]"
              :type="`${item.category || 'text'}`"
              :style="`width: ${item.width || '100%'}`"
              :clearable="item.clearable === undefined || item.clearable"
              filterable
              :placeholder="item.placeholder"
              :disabled="item.disabled || disabled"
            />
          </el-form-item>
        </template>

        <!-- 下拉选择框 -->
        <template v-if="item.type === 'select'">
          <el-form-item
            :label="item.label"
            :prop="item.model"
            :key="item.model"
          >
            <el-select
              v-model.trim="form[item.model]"
              :style="`width:${item.width || '100%'}`"
              clearable
              :multiple="item.multiple === true"
              filterable
              :placeholder="item.placeholder || ''"
              :disabled="item.disabled || disabled"
            >
              <el-option
                v-for="(i, key) in item.options"
                :key="i[item.value] || key"
                :label="i[item.label] || i.label"
                :value="i[item.value] || i.value"
              >
                <span style="float: left">{{ i[item.label] || i.label }}</span>
                <span v-if="i.department || i.mobile" style="float: right; color: #8492a6; font-size: 13px; margin-left: 10px;">
                  {{ i.department }} {{ i.mobile }}
                </span>
              </el-option>
            </el-select>
          </el-form-item>
        </template>

        <!-- 日期范围选择器 -->
        <template v-if="item.type === 'date-picker-daterange'">
          <el-form-item
            :prop="item.model"
            :label="item.label"
            :key="item.model"
          >
            <el-date-picker
              v-model.trim="form[item.model]"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :disabled="item.disabled || disabled"
            >
            </el-date-picker>
          </el-form-item>
        </template>

        <!-- 日期选择器 -->
        <template v-if="item.type === 'date-picker-data'">
          <el-form-item
            :prop="item.model"
            :label="item.label"
            :key="item.model"
          >
            <el-date-picker
              v-model.trim="form[item.model]"
              type="date"
              :clearable="item.clearable === undefined || item.clearable"
              :placeholder="item.placeholder"
              :format="item.format || 'yyyy-MM-dd'"
              :value-format="item.format || 'yyyy-MM-dd'"
              :disabled="item.disabled || disabled"
            >
            </el-date-picker>
          </el-form-item>
        </template>

        <!-- 开关 -->
        <template v-if="item.type === 'switch'">
          <el-form-item
            :prop="item.model"
            :label="item.label"
            :key="item.model"
          >
            <el-switch v-model="form[item.model]" :disabled="item.disabled || disabled"></el-switch>
          </el-form-item>
        </template>

        <!-- 复选框 -->
        <template v-if="item.type === 'checkbox'">
          <el-form-item
            :prop="item.model"
            :label="item.label"
            :key="item.model"
          >
            <el-checkbox-group v-model="form[item.model]">
              <el-checkbox
                v-for="(opt, index) in item.options"
                :key="index"
                :label="opt.value"
                :disabled="item.disabled || disabled"
              >{{ opt.label }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </template>

        <!-- 单选框 -->
        <template v-if="item.type === 'radio'">
          <el-form-item
            :prop="item.model"
            :label="item.label"
            :key="item.model"
          >
            <el-radio-group v-model="form[item.model]" :disabled="item.disabled || disabled">
              <el-radio
                v-for="(opt, index) in item.options"
                :key="index"
                :label="opt.value"
              >{{ opt.label }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </template>

        <!-- 输入框textarea -->
        <template v-if="item.type === 'textarea'">
          <el-form-item
            :label="item.label"
            :prop="item.model"
            :key="item.model"
          >
            <el-input
              type="textarea"
              v-model.trim="form[item.model]"
              :style="`width: ${item.width || '100%'};`"
              :clearable="item.clearable === undefined || item.clearable"
              :placeholder="item.placeholder"
              :rows="item.row || 5"
              :disabled="item.disabled || disabled"
            />
          </el-form-item>
        </template>

        <!-- 密码输入框 -->
        <template v-if="item.type === 'password'">
          <el-form-item
            :label="item.label"
            :prop="item.model"
            :key="item.model"
          >
            <el-input
              v-model.trim="form[item.model]"
              type="password"
              :style="`width: ${item.width || '100%'}`"
              :clearable="item.clearable === undefined || item.clearable"
              filterable
              :placeholder="item.placeholder"
              :disabled="item.disabled || disabled"
            />
          </el-form-item>
        </template>

        <!-- 图片上传 -->
        <template v-if="item.type === 'image'">
          <el-form-item
            :label="item.label"
            :prop="item.model"
            :key="item.model"
          >
            <el-upload
              class="avatar-uploader"
              action="/api/upload"
              :show-file-list="false"
              :on-success="(res) => handleImageSuccess(res, item.model)"
              :before-upload="beforeImageUpload"
              :headers="{ 'Authorization': token }"
            >
              <img v-if="form[item.model]" :src="form[item.model]" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </template>

        <!-- ... -->
      </template>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'CommonForm',
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    // 生成el-form-item的数组
    formItemList: {
      type: Array,
      default: () => []
    },
    // 是否行内表单模式
    inline: {
      type: Boolean,
      default: false
    },
    // el-form-item的label宽度
    labelWidth: {
      type: String,
      default: '200px'
    },
    // 表单校验规则
    rules: {
      type: Object,
      default: () => {}
    },
    // 整表只读（如查看模式）
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      token: localStorage.getItem('token') || ''
    }
  },
  methods: {
    // 返回经过校验的表单
    returnForm() {
      // 表单校验
        this.$refs['form'].validate(valid => {
        this.$emit('getForm', { form: this.form, valid: valid })
      })
    },
    // 重置表单
    resetForm() {
      // 重置复选框
      this.$refs.form.resetFields()
    },
    handleImageSuccess(res, model) {
      if (res.code === 200) {
        this.$set(this.form, model, res.data.url)
        this.$message.success('上传成功')
      } else {
        this.$message.error(res.message || '上传失败')
      }
    },
    beforeImageUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG/PNG/GIF 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__label {
  text-align: right;
}

::v-deep .el-textarea__inner {
  //el_input中的隐藏属性
  resize: none; //禁止拉伸
}

.avatar-uploader {
  ::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 178px;
    height: 178px;

    &:hover {
      border-color: #409EFF;
    }
  }
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
